import { Link } from 'react-router-dom';
import { footerLinks, siteConfig } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-compass-3-line text-lg text-background-50"></i>
              </div>
              <span className="font-semibold text-lg text-background-50">
                {siteConfig.siteName}
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              无需编程基础，轻松创建并在线发布你的专属导航页。支持自定义分类、链接管理、一键部署。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">产品</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.product.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">支持</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">公司</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} {siteConfig.siteName}. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="GitHub" rel="nofollow">
              <i className="ri-github-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}